module.exports = __webpack_public_path__ + "img/noticeon.4d4ed2f8.png";